import { render, staticRenderFns } from "./PianificaNavbar.vue?vue&type=template&id=38a363ae&scoped=true&"
import script from "./PianificaNavbar.vue?vue&type=script&lang=js&"
export * from "./PianificaNavbar.vue?vue&type=script&lang=js&"
import style0 from "./PianificaNavbar.vue?vue&type=style&index=0&id=38a363ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a363ae",
  null
  
)

export default component.exports